import React from "react";
const OriginalityDeviceContext = React.createContext({
    isLoading: false,
    process:null,
    postToken:null,
    pid:null,
    components:null,
    token:null,
    handleUpdateStep:()=>{},
    handlePid:()=>{},
    handleLoading:()=>{},
    handleProcess:()=>{},
    handleError:()=>{},
    handleComponents:()=>{},
    handleGetProcess:()=>{},
    handleCreateProcess:()=>{},
    handleSkip:()=>{},
    handleReset:()=>{},
    handleRedirectToDivar:()=>{}


});
export default OriginalityDeviceContext;